import { FC } from 'react'
import clsx from 'clsx'
import { KTIcon } from '../../../helpers'

type Props = {
    href: string
    title: string
    icon?: string
    fontIcon?: string
    download?: boolean
}

const MenuDownloadItem: FC<Props> = ({ href, title, icon, fontIcon, download = true }) => {
    return (
        <div className='menu-item me-lg-1'>
            <a
                className='menu-link py-3'
                href={href}
                download={download}
                target='_blank'
                rel='noopener noreferrer'
            >
                {icon && (
                    <span className='menu-icon'>
                        <KTIcon iconName={icon} className='fs-2' />
                    </span>
                )}

                {fontIcon && (
                    <span className='menu-icon'>
                        <i className={clsx('bi fs-3', fontIcon)}></i>
                    </span>
                )}

                <span className='menu-title'>{title}</span>
            </a>
        </div>
    )
}

export { MenuDownloadItem }
